import {
    StyleSheet
} from "react-native";
import type {
    BarChartMeasuresConstantType,
    BarChartDynamicStyleType,
    BarChartMeasures
} from "./type";

export const getBarChartMeasures = ({
    shapeConfigs,
    typography,
    radiuses,
    spaces
}: BarChartMeasuresConstantType): BarChartMeasures => {
    return {
        labelWeight: typography.labelSmallSize.fontWeight,
        bandRatio: shapeConfigs.chartBandRatio,
        typography: typography.bodySmallSize,
        gap: shapeConfigs.chartSegmentGap,
        barMax: shapeConfigs.chartBarMax,
        spacingMd: spaces.spacingMd,
        spacingSm: spaces.spacingSm,
        spacingXs: spaces.spacingXs,
        radius: radiuses.chartBar
    };
};

const stylesheet = StyleSheet.create({
    container: {
        width: "100%"
    }
});

export const useStyles = ({
    colors
}: BarChartDynamicStyleType) => {
    const styles = {
        hover: colors.system.state.overlay.hover.default,
        negative: colors.chart.diverging.negative,
        positive: colors.chart.diverging.positive,
        high: colors.content.text.high,
        mid: colors.content.text.mid,
        low: colors.content.text.low,
        muted: colors.chart.muted
    };

    return styles;
};
export default stylesheet;
